import React from "react";

import "./App.css";

import Home from "./pages/Home/Home.page.js";

function App() {
    return (
        <div className="App">
            <Home />
        </div>
    );
}

export default App;
